import { Component, OnInit, } from '@angular/core'
import { AppConfigService } from '../../service/app-config.service'
import { PersonService } from '../../service/person.service'
declare var $: any
@Component({
  selector: 'app-membershipCommittee',
  templateUrl: './membership.component.html',
  styleUrls: ['./membership.component.styl', '../../share/breadcrumb/breadcrumb.component.styl']
})
export class MembershipCommittee implements OnInit {
  modal = {
    title: 'About ChinaICAC Membership Committee',
  };


  constructor(private personService: PersonService,
    private appconfigService: AppConfigService,) {

  }

  ngOnInit() {
    window.scrollTo(0, 0)
  }
}



// WEBPACK FOOTER //
// /Users/apple/Documents/object/chinaicac-portal/src/app/about/membership-committee/membership.component.ts